<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!--Header-->
							<div class="page_header">Task Assignment</div>
							<!--Header-->
							<div class="page_main">
								<el-form ref="form" :model="info" label-position="top" class="request-form">
									<el-form-item label="CAPA ID" class="full-width-item">
										<div class="gray-input">
											{{ info.request_id || "/" }}
										</div>
									</el-form-item>
									<div class="form-grid">
										<!-- Left Side -->
										<div class="form-col">
											<el-form-item label="Status">
												<div class="gray-input">
													{{ info.status_name || '/' }}
												</div>
											</el-form-item>
											<el-form-item label="Priority">
												<div class="gray-input">
													{{ info.priority || '/' }}
												</div>
											</el-form-item>
											<el-form-item label="Investigator">
												<div class="gray-input">
													{{ info.investigator || '/' }}
												</div>
											</el-form-item>
										</div>
										<!-- Right Side -->
										<div class="form-col">
											<el-form-item label="Request Date">
												<div class="gray-input">
													{{ info.time1 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Acceptance Date">
												<div class="gray-input">
													{{ info.time2 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Start Date">
												<div class="gray-input">
													{{ info.time3 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Investigation Completion Date">
												<div class="gray-input">
													{{ info.time4 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Implementation Start Date">
												<div class="gray-input">
													{{ info.time5 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Implementation Completion Date">
												<div class="gray-input">
													{{ info.time6 || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Close Date">
												<div class="gray-input">
													{{ info.pass_time || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<div class="text-tip">CAPA Description</div>
									<el-form-item label="Description of Issue, Concern, Idea, or Opportunity" class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
									<div class="text-tip">Background Information</div>
									<div class="form-grid">
										<!-- Left Side -->
										<div class="form-col">
											<el-form-item label="Requester">
												<div class="gray-input">
													{{ info.username || '/' }}
												</div>
											</el-form-item>
											<!-- <el-form-item label="Organization">
												<div class="gray-input">
													{{ info.company_name || "/" }}
												</div>
											</el-form-item> -->
										</div>
										<!-- Right Side -->
										<div class="form-col">
											<el-form-item label="Source Type">
												<div class="gray-input">
													{{ info.source_type || "/" }}
												</div>
											</el-form-item>
											<el-form-item label="Department">
												<div class="gray-input">
													{{ info.departments_name || "/" }}
												</div>
											</el-form-item>
										</div>
									</div>
									<el-form-item label="Source Information" class="full-width-item">
										<div class="gray-input">
											{{ info.source_info || "/" }}
										</div>
									</el-form-item>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">CAPABackground File</div>
										</div>
										<el-table :data="backdocTableData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Data">
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="name" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">
												Documents Affected by Issues, Concerns, Ideas, or Opportunities
											</div>
										</div>
										<el-table :data="affectArticleTableData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Data">
											<el-table-column prop="" label="Document Type" min-width="180" sortable>
												<template #default="scope">
													<div v-if="scope.row.article_type == 1">Document</div>
													<div v-if="scope.row.article_type == 2">Equipment</div>
													<div v-if="scope.row.article_type == 3">Product</div>
													<div v-if="scope.row.article_type == 4">Tools</div>
													<div v-if="scope.row.article_type == 5">Other</div>
												</template>
											</el-table-column>
											<el-table-column prop="article_id" label="Document ID" min-width="110" sortable />
											<el-table-column prop="article_name" label="Document Name" min-width="110" sortable />
											<el-table-column prop="article_revision" label="Document Revision" min-width="140" sortable></el-table-column>
											<el-table-column prop="" label="Product Serial Number" min-width="180" sortable>
												<template #default="scope">
													{{ scope.row.serial_number || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Batch Number" min-width="160" sortable>
												<template #default="scope">
													{{ scope.row.lot_number || 'N/A' }}
												</template>
											</el-table-column>
											<el-table-column prop="" label="Purchased Product?" min-width="200" sortable>
												<template #default="scope">
													<div v-if="scope.row.is_buy == 1">Yes</div>
													<div v-if="scope.row.is_buy == 2">No</div>
													<div v-else></div>
												</template>
											</el-table-column>
											<el-table-column prop="" label="Product Supplier" min-width="200" sortable>
												<template #default="scope">
													{{ scope.row.supplier_name || '' }}
												</template>
											</el-table-column>
										</el-table>
									</div>
									<div class="file-panel">
										<div class="panel-header">
											<div class="table-title">Correction</div>
										</div>
										<el-table :data="correctionTableData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Data">
											<el-table-column label="Description" prop="description" min-width="300" />
											<el-table-column label="File Name" prop="" min-width="300">
												<template #default="scope">
													<a :href="scope.row.url" target="_blank">{{ scope.row.name }}</a>
												</template>
											</el-table-column>
										</el-table>
									</div>
									<!-- Flowchart -->
									<div class="section-card" style="margin-top: 20px">
										<div class="text-tip">Flowchart</div>
										<div class="flow-scroll">
											<div class="flow-wrapper">
												<svg class="flow-svg" viewBox="0 0 1220 180">
													<defs>
														<marker id="arrow" markerWidth="8" markerHeight="8" refX="7"
															refY="3" orient="auto" markerUnits="strokeWidth">
															<path d="M0,0 L0,6 L7,3 z" fill="#333" />
														</marker>
													</defs>
													<path d="M260 80 C295 42, 340 36, 385 36" class="flow-line"
														marker-end="url(#arrow)" />
													<path d="M260 100 C300 138, 340 145, 390 145" class="flow-line"
														marker-end="url(#arrow)" />
													<path d="M475 36 C515 38, 540 50, 560 80" class="flow-line"
														marker-end="url(#arrow)" />
													<path d="M475 145 C520 143, 545 130, 560 100" class="flow-line"
														marker-end="url(#arrow)" />
													<line x1="650" y1="90" x2="690" y2="90" class="flow-line"
														marker-end="url(#arrow)" />
													<line x1="780" y1="90" x2="820" y2="90" class="flow-line"
														marker-end="url(#arrow)" />
													<line x1="925" y1="90" x2="965" y2="90" class="flow-line"
														marker-end="url(#arrow)" />
													<line x1="1055" y1="90" x2="1090" y2="90" class="flow-line"
														marker-end="url(#arrow)" />
												</svg>
												<div class="flow-node node-submit" :class="nowStep == 1 ? 'actived' : ''">
													Submit New Request
												</div>
												<div class="flow-node node-hold" :class="nowStep == 2 ? 'actived' : ''">
													Request Paused
												</div>
												<div class="flow-node node-approve" :class="nowStep == 3 ? 'actived' : ''">
													Review, Prioritization & Assignment
												</div>
												<div class="flow-node node-investigate" :class="nowStep == 4 ? 'actived' : ''">
													Investigation & Planning
												</div>
												<div class="flow-node node-plan" :class="nowStep == 5 ? 'actived' : ''">Approval Plan</div>
												<div class="flow-node node-current" :class="nowStep == 6 ? 'actived' : ''">
													Implementation & Verification
												</div>
												<div class="flow-node node-capa" :class="nowStep == 7 ? 'actived' : ''">
													CAPA Effectiveness Verification
												</div>
												<div class="flow-node node-closed" :class="nowStep == 8 ? 'actived' : ''">End</div>
											</div>
										</div>
									</div>
									<!-- Task History -->
									<div class="file-panel">
										<div class="table-card-header" style="padding: 12px 16px;">
											<div class="table-title">
												Task History
											</div>
										</div>
										<div>
											<!-- Search Box -->
											<div style="display:flex;justify-content:space-between;align-items:center;margin:10px;">
												<div>Total {{ matchCount }} items</div>
												<el-input v-model="searchKeyword" placeholder="Enter keywords (space-separated supported)" clearable style="width:300px" />
											</div>
											<el-table :data="filteredTableData" border stripe header-cell-class-name="table-header-cell" class="file-table" empty-text="No Data">
												<!-- Task Name -->
												<el-table-column prop="step_name" label="Task Name" min-width="120">
													<template #default="scope">
														<span v-html="highlight(scope.row.step_name)"></span>
													</template>
												</el-table-column>
												<!-- Owner -->
												<el-table-column label="Task Owner" min-width="150">
													<template #default="scope">
														<span v-html="highlight(scope.row.apply_username || 'Unclaimed')"></span>
													</template>
												</el-table-column>
												<!-- Organization -->
												<!-- <el-table-column label="Owner Organization" min-width="180">
													<template #default="scope">
														<span v-html="highlight(scope.row.company_name || 'N/A')"></span>
													</template>
												</el-table-column> -->
												<!-- Department -->
												<el-table-column label="Owner Department" min-width="180">
													<template #default="scope">
														<span v-html="highlight(scope.row.departments_name || 'N/A')"></span>
													</template>
												</el-table-column>
												<!-- Status -->
												<el-table-column label="Task Status/Result" min-width="150">
													<template #default="scope">
														<span v-html="highlight(getStatusText(scope.row.flow_leixing, scope.row.status))"></span>
													</template>
												</el-table-column>
												<!-- Comments -->
												<el-table-column prop="remark" label="Comments" min-width="210">
													<template #default="scope">
														<span v-html="highlight(scope.row.remark || '')"></span>
													</template>
												</el-table-column>
												<!-- Due Time -->
												<el-table-column prop="end_time" label="Task Due Date" min-width="150">
													<template #default="scope">
														<span v-html="highlight(scope.row.end_time)"></span>
													</template>
												</el-table-column>
												<!-- Completion Time -->
												<el-table-column label="Completion Date" min-width="150">
													<template #default="scope">
														<span v-html="highlight(scope.row.app_time)"></span>
													</template>
												</el-table-column>
											</el-table>
										</div>
									</div>
									<div class="text-tip" style="margin-top: 20px">
										Task Assignment Information
									</div>
									<el-form-item label="Process Name" class="full-width-item">
										<div class="gray-input">
											{{ "CAPARequest" }}
										</div>
									</el-form-item>
									<el-form-item label="Task Name" class="full-width-item">
										<div class="gray-input">
											{{ info.step_name || "/" }}
										</div>
									</el-form-item>
									<el-form-item label="Task Description" class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
									<el-form-item label="Process Type" class="full-width-item">
										<div class="gray-input">
											{{ "CAPARequest" }}
										</div>
									</el-form-item>
									<el-form-item label="Request ID" class="full-width-item">
										<div class="gray-input">
											{{ info.request_id || "/" }}
										</div>
									</el-form-item>
									<el-form-item label="Product Description" class="full-width-item">
										<div class="gray-input">
											{{ info.description || "/" }}
										</div>
									</el-form-item>
									<el-form-item label="Task Owner" class="full-width-item">
										<div class="gray-input">
											{{ info.apply_username || "/" }}
										</div>
									</el-form-item>
									<el-form-item label="Task Due Date" class="full-width-item">
										<div class="gray-input">
											{{ info.end_time || "/" }}
										</div>
									</el-form-item>
									<!-- Bottom Buttons -->
									<div class="footer-actions">
										<el-button type="primary" size="small" @click="handleClaim">
											Claim Task
										</el-button>
										<el-button type="primary" size="small" @click="handleMove">
											Assign to Another User
										</el-button>
										<el-button type="primary" size="small" @click="handleClose">
											Close
										</el-button>
									</div>
								</el-form>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--Assignment Dialog -->
		<el-dialog title="Assign to Another User" :visible.sync="dialogVisible" width="30%">
			<div class="move_box">
				<div class="form_box">
					<div style="padding-bottom: 20px;font-weight: bold;font-size: 16px;">Please complete the following information</div>
					<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
						<div class="input_el">
							<div class="tit required">Assigned By</div>
							<el-form-item label="" prop="uid">
								<el-select v-model="ruleForm.uid" filterable placeholder="Please Select" style="width: 100%;">
									<el-option
										v-for="value in usersList"
										:key="value.id"
										:label="value.username"
										:value="value.id"
									></el-option>
								</el-select>
							</el-form-item>
						</div>
						<div class="input_el">
							<div class="tit required">Password</div>
							<el-form-item label="" prop="signature">
								<el-input v-model="ruleForm.signature" placeholder="Please Enter" clearable show-password></el-input>
							</el-form-item>
						</div>
					</el-form>
				</div>
				<div class="btn_box">
					<van-button  class="btn_el" type="default" round @click="dialogVisible = false">Cancel</van-button>
					<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)" @click="submitForm('ruleForm')">Confirm</van-button>
				</div>
			</div>
		</el-dialog>
		<!--Assignment Dialog -->
	</div>
</template>

<script>
import {
	resourcesApplyDetail,
	resourcesApplyClaim,
	resourcesApplyAssignment,
	resourcesApplyHandle,
	resourcesApplyEditversion
} from "@/api/docManage/changeRequest/index";
import { usersList } from '@/api/system/user';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from 'js-md5';
import moment from 'moment';
export default {
	name: "CapaDetail",
	components: {
		headers,
		slider,
	},
	data() {
		return {
			info: {},
			backdocTableData: [],
			affectArticleTableData: [],
			correctionTableData: [],
			historyTableData: [],
			searchKeyword: '',
			matchCount: 0,
			nowStep: null,
			usersList: [],
			dialogVisible: false,
			ruleForm: {
				uid: '',
				signature: ''
			},
			rules: {
				uid: [
					{ required: true, message: 'Please Select', trigger: 'change' },
				],
				signature: [
					{ required: true, message: 'Please Enter', trigger: 'blur' },
				]
			},
		};
	},
	mounted() {
		let that = this;
		//Requester List
		usersList({ page: 1, page_size: 9999, status: 1 }).then(res => {
			that.usersList = res.data.data;
		});
		resourcesApplyDetail({ id: that.$route.query.oid }).then(res => {
			if(res.code == 200) {
				// console.log(res.data);
				if(res.data.step < 3) {
					that.info.request_id = 'New Request' + '（'+res.data.request_id+'）';
				}else {
					that.info.request_id = res.data.request_id;
				}
				that.info.status_name = res.data.status_name;
				that.info.priority = res.data.priority;
				that.info.investigator = res.data.investigator;
				that.info.description = res.data.description;
				that.info.username = res.data.username;
				// that.info.company_name = res.data.company_name;
				that.info.source_type = res.data.source_type;
				that.info.departments_name = res.data.departments_name;
				that.info.source_info = res.data.source_info;
				that.info.time1 = res.data.time1;
				that.info.time2 = res.data.time2;
				that.info.time3 = res.data.time3;
				that.info.time4 = res.data.time4;
				that.info.time5 = res.data.time5;
				that.info.time6 = res.data.time6;
				that.info.pass_time = res.data.pass_time;
				that.info.step_name = res.data.step_name;
				that.info.apply_username = res.data.apply_username;
				that.info.end_time = that.info.end_time;
				that.historyTableData = res.data.apply_list;
				// that.nowStep = res.data.step;
				switch(res.data.status) {
					case 1:  //Submit New Request
						that.nowStep = 1;
					break;
					case 2:  //Review, Prioritization & Assignment
						that.nowStep = 3;
					break;
					case 3:  //Review, Prioritization & Assignment
						that.nowStep = 3;
					break;
					case 4:  //Paused
						that.nowStep = 2;
					break;
					case 5:
						if(res.data.step == 4) {
							that.nowStep = 4;  //Investigation & Planning
						}else {
							that.nowStep = 5;  //Approval Plan
						}
					break;
					case 6:  //Implementation & Verification
						that.nowStep = 6;
					break;
					case 7:  //CAPA Effectiveness Verification
						that.nowStep = 7;
					break;
					case 8:  //End
						that.nowStep = 8;
					break;
				}
				//Display CAPA Background File
				that.backdocTableData = res.data.capabackground_list;
				//Display Correction File
				that.correctionTableData = res.data.capacorrections_list;
				//Display Affected Documents
				that.affectArticleTableData = res.data.capaarticle_list;
			}
		});
	},
	computed: {
		// Tokenization
		keywords() {
			if (!this.searchKeyword) return []
			return this.searchKeyword
				.toLowerCase()
				.split(/\s+/)
				.filter(Boolean)
		},
		// Filter
		filteredTableData() {
			if (!this.keywords.length) {
				this.matchCount = this.historyTableData.length
				return this.historyTableData
			}
			const result = this.historyTableData.filter(row => {
				return this.matchRow(row)
			})
			this.matchCount = result.length

			this.$nextTick(() => {
				this.scrollToFirst()
			})
			return result
		}
	},
	methods: {
		// Line Match
		matchRow(row) {
			const fields = [
				row.step_name,
				row.apply_username || 'Unclaimed',
				// row.company_name || 'N/A',
				row.departments_name || 'N/A',
				this.getStatusText(row.flow_leixing, row.status),
				row.remark || '',
				row.end_time,
				row.app_time
			]
			const text = fields.join(' ').toLowerCase()
			return this.keywords.every(k => text.includes(k))
		},
		// Status Mapping
		getStatusText(flow_leixing, status) {
			if(flow_leixing == 1) {
				let map = {
					1: 'In Progress',
					2: 'Approve',
					3: 'Reject',
					4: 'Auto Reject',
					9: 'Withdrawn'
				}
				return map[status] || ''
			}else {
				let map = {
					1: 'Unread',
					2: 'Read'
				}
				return map[status] || ''
			}
		},
		// Highlight
		highlight(text) {
			if (!text) return ''
			let result = text.toString()
			this.keywords.forEach(k => {
				const reg = new RegExp(
					`(${k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
					'gi'
				)
				result = result.replace(reg, '<span class="highlight">$1</span>')
			})
			return result
		},
		// Scroll
		scrollToFirst() {
			const table = this.$refs.tableRef
			if (!table) return
			const el = table.$el.querySelector('.el-table__body-wrapper tbody tr')
			if (el) {
				el.scrollIntoView({ behavior: 'smooth', block: 'center' })
			}
		},
		//Claim
		handleClaim() {
			let that = this;
			that.$confirm("Are you sure you want to claim this task?", "Notice", {
				type: "warning",
			}).then(() => {
				that.$toast.loading({ duration: 0, forbidClick: true });
				//Claim Task
				resourcesApplyClaim({
					id: that.$route.query.oid
				}).then(res => {
					if(res.code == 200) {
						that.$toast.clear();
						that.$message.success('Operation Successful');
						setTimeout(() => {
							that.$router.back();
						}, 800);
					}
				});
			}).catch(() => {});
		},
		//Assign to Another User
		handleMove() {
			let that = this;
			that.dialogVisible = true;
		},
		//Confirm Assignment
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					that.$toast.loading({ duration: 0, forbidClick: true });
					//Assign Task
					resourcesApplyAssignment({
						id: that.$route.query.oid,
						uid: that.ruleForm.uid,
						signature: md5(that.ruleForm.signature+'AiisoQms2026')
					}).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.dialogVisible = false;
							that.$message.success('Operation Successful');
							setTimeout(() => {
								that.$router.back();
							}, 800);
						}
					});
				}else {
					return false;
				}
			});
		},
		handleClose() {
			let that = this;
			that.$router.back();
		},
	},
};
</script>


<style lang="less" scoped>
	//Save Signature
	.move_box{
		.btn_box{
			text-align: right;
			.btn_el{
				margin-left: 10px;
				padding: 12px 24px;
				.van-button__text{
					font-size: 16px;
				}
			}
		}
		.form_box{
			.input_el{
				.tit{
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}
				.required::before {
					content: '*';
					color: red;
					margin-right: 2px;
				}
			}
		}
	}
	//Main Content
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//Header
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>

<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.form-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
		column-gap: 28px;
		align-items: start;
	}

	.form-col {
		display: flex;
		flex-direction: column;
	}

	.full-width-item {
		margin-top: 8px;
	}

	/* label Style */
	::v-deep .el-form-item__label {
		padding-bottom: 8px;
		font-size: 14px;
		line-height: 20px;
		color: #2f343b;
		font-weight: 700;
	}

	/* Unified Input Style */
	.gray-input {
		background: #e9ecef;
		border: 1px solid #cfd5db;
		color: #2f343b;
		border-radius: 8px;
		padding-left: 15px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
	}

	.text-tip {
		background-color: #fafafa;
		font-size: 20px;
		font-weight: 700;
		margin-bottom: 20px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.custom-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 10px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 12px 16px;
	}

	.table-title {
		font-size: 18px;
		font-weight: 700;
		color: #2f343b;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	.flow-scroll {
		width: 100%;
		overflow-x: auto;
		overflow-y: hidden;
	}

	.flow-wrapper {
		position: relative;
		width: 1220px;
		height: 180px;
		margin: 0 auto;
	}

	.flow-svg {
		position: absolute;
		left: 0;
		top: 0;
		width: 1220px;
		height: 180px;
		z-index: 1;
		overflow: visible;
	}

	.flow-line {
		fill: none;
		stroke: #333;
		stroke-width: 1.2;
	}

	.flow-node {
		position: absolute;
		z-index: 2;
		box-sizing: border-box;
		background: #f6f7fb;
		border: 1px solid #9a82ff;
		color: #111;
		font-size: 13px;
		font-weight: 700;
		line-height: 1.45;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.node-submit {
		left: 170px;
		top: 60px;
		width: 90px;
		height: 60px;
	}

	.node-hold {
		left: 385px;
		top: 18px;
		width: 90px;
		height: 56px;
	}

	.node-approve {
		left: 390px;
		top: 102px;
		width: 90px;
		height: 76px;
	}

	.node-investigate {
		left: 560px;
		top: 60px;
		width: 90px;
		height: 60px;
	}

	.node-plan {
		left: 690px;
		top: 72px;
		width: 90px;
		height: 36px;
	}

	.node-current {
		left: 820px;
		top: 60px;
		width: 105px;
		height: 60px;
	}
	.actived{
		background: #005baa;
		border-color: #9a82ff;
		color: #fff;
	}

	.node-capa {
		left: 965px;
		top: 48px;
		width: 90px;
		height: 84px;
	}

	.node-closed {
		left: 1090px;
		top: 72px;
		width: 55px;
		height: 36px;
	}

	.solution-plan {
		width: 100%;
		color: #303133;
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.plan-header {
		display: flex;
		align-items: center;
		margin-bottom: 8px;
	}

	.plan-title {
		font-size: 20px;
		font-weight: 700;
		color: #1f2d3d;
		margin-right: 8px;
	}

	.toggle-btn {
		padding: 0;
		font-size: 13px;
	}

	.plan-card {
		border: 1px solid #dcdfe6;
		border-radius: 4px;
		background: #fff;
		overflow: hidden;
	}

	.plan-section {
		padding: 28px 20px 18px;
	}

	.section-title {
		margin: 0 0 26px;
		font-size: 24px;
		font-weight: 700;
		color: #303133;
	}

	.sub-title {
		font-size: 20px;
		font-weight: 700;
		color: #303133;
		margin-bottom: 20px;
	}

	.form-block {
		margin-bottom: 10px;
	}

	.field-label {
		display: block;
		margin-bottom: 5px;
		font-size: 14px;
		font-weight: 700;
		color: #303133;
	}

	.section-toggle {
		margin-top: 12px;
	}

	.section-toggle .el-button {
		padding: 0;
		font-size: 14px;
		font-weight: 600;
	}

	.divider {
		height: 1px;
		background: #ebeef5;
	}

	.custom-table {
		margin-bottom: 14px;
		width: 100%;
	}

	.el-icon-arrow-down,
	.el-icon-arrow-up {
		margin-left: 2px;
	}

	.footer-actions {
		display: flex;
		margin-top: 50px;
		justify-content: center;
		align-self: center;
	}

	.action-task-panel {
		margin-top: 20px;
	}
	::v-deep .highlight {
	  background: linear-gradient(120deg, #f56c6c, #ff9a9e);
	  color: #fff;
	  padding: 0 3px;
	  border-radius: 3px;
	}
</style>